export default __webpack_public_path__ + "static/media/waterpoolImg.a6dc43d3.jpeg";